export default __webpack_public_path__ + "static/media/download-svgrepo-com.295d3a3b.svg";